


















import { Component, Vue } from 'vue-property-decorator';
import * as firebase from 'firebase/app';

@Component
export default class Login extends Vue {
  public email = '';

  public password = '';

  public loginError = false;

  public async login() {
    try {
      const auth = await firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password);

      if (auth) {
        this.$router.replace('/logs/pleural');
      }
    } catch (_) {
      this.loginError = true;
      this.email = '';
      this.password = '';
    }
  }
}
